export enum language {
    Spanish = 'es',
    English = 'en'
}